import $ from 'jquery';

const autocomplete  = $( '.search-autocomplete' ),
      searchBar     = $( '#search-bar' ),
      searchType    = $( 'select[name="searched_type"]' ),
      searchOptions = $( 'select[name="searched_type"] option' ),
      list          = $( '.search-autocomplete__content' ),
      loadMoreImage = $( '.load-more__image' );

let timeout_id = 0;

let get_results = () => {
	$.ajax( {
		type:       'GET',
		url:        psh_vars.rest_route.psh_search_suggest,
		data:       {
			search: searchBar.val()
		},
		beforeSend: () => {
			autocomplete.show();
			loadMoreImage.show();
			list.empty();
		},
		complete:   function () {
			loadMoreImage.hide();
		},
		success:    result => {
			list.empty();

			if ( result.products.length === 0 ) {
				autocomplete.hide();
			}

			result.products.map( ( product ) =>
				list.append(
					`<a href="${product.permalink}" class="search-autocomplete__content--item">
									<span class="search-autocomplete__content--item-value">${product.value}</span>
									<span class="search-autocomplete__content--item-name">${product.name}</span>
							</a>`
				) );

			const items = $( '.search-autocomplete__content--item' );
			items.each( function ( index, item ) {
				const replace  = this.innerHTML.replace( searchBar.val(), '<strong>' + searchBar.val() + '</strong>' );
				this.innerHTML = replace;

				$( item ).on( 'click', function ( e ) {
					e.preventDefault();
					let link = $( this ).attr( 'href' );

					$.ajax( {
						type:     'GET',
						url:      psh_vars.rest_route.factory_data_statis,
						data:     {
							search: searchBar.val()
						},
						complete: () => {
							window.location.href = link;
						}
					} );
				} )
			} );

			items.on( 'click', e => {
				searchBar.val( e.target.innerText );
			} );
		}
	} );
};

searchType.on( 'change', ( e ) => {
	searchOptions.each( function () {
		const optionValue = $( this ).val();

		if ( optionValue === e.target.value ) {
			$( this ).attr( 'selected', '' );
		} else {
			$( this ).removeAttr( 'selected' );
		}
	} );
} );

searchBar.on( 'keyup paste', ( event ) => {
	if ( searchBar.val().length <= 2 || event.key === 'Enter' || searchType.val() === 'start' ) {
		if ( autocomplete.is( ':visible' ) ) {
			autocomplete.hide();
		}
		list.empty();
		return '';
	}

	clearTimeout( timeout_id );
	timeout_id = setTimeout( get_results, 500 );
} );

$( document ).on( 'mouseup', function ( e ) {
	let resultContainer = $( ".search-autocomplete" );

	if ( !resultContainer.is( e.target ) && resultContainer.has( e.target ).length === 0 ) {
		resultContainer.hide();
	}
} );
